konnyScript(function($){

    if($('#kncr_award_swiper_slide .awardTxt').length > 0){
      var award_text_height = [];
      $('#kncr_award_swiper_slide .awardTxt').each(function(){
        award_text_height.push($(this).height());
      })
  
      var award_max_height = Math.max(...award_text_height);
      $('#kncr_award_swiper_slide .awardTxt').height(award_max_height);
    }
    
    var swiper = new Swiper("#kncr_tutorial_swiper_slide", {
        slidesPerView: 1.05,
        slidesPerGroup: 1,
        spaceBetween: 15,
        loop: false,
        scrollbar: {
            el: '#kncr_tutorial_swiper_slide .swiper-scrollbar',
        },
        pagination: {
            el: '#kncr_tutorial_swiper_slide .swiper-pagination',
        },
        navigation: {
            nextEl: '#kncr_tutorial_swiper_slide .swiper-button-next',
            prevEl: '#kncr_tutorial_swiper_slide .swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 750px
            750: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
        /*
        on: {
          slideChangeTransitionStart:function(){
            $('#kncr_tutorial_swiper_slide .swiper-slide').each(function(){
              var video = $(this).children('video').get(0);
              if($(this).hasClass('swiper-slide-active')){
                video.play();
              }else if(video.played){
                video.pause();
              }
            })
          }
        },
        */
    });
    /*
    $(window).scroll(function(){
      if($('#kncr_tutorial_swiper_slide').length){
        if($('#kncr_tutorial_swiper_slide').is(":visible")){
          $('#kncr_tutorial_swiper_slide .swiper-slide-active video').get(0).play();
        }else{
          $('#kncr_tutorial_swiper_slide .swiper-slide video').get(0).pause();
        }
      }
    });
    */
    
    var swiper = new Swiper("#kncr_award_swiper_slide", {
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 15,
        loop: false,
        scrollbar: {
            el: '#kncr_award_swiper_slide .swiper-scrollbar',
        },
        pagination: {
            el: '#kncr_award_swiper_slide .swiper-pagination',
        },
        navigation: {
            nextEl: '#kncr_award_swiper_slide .swiper-button-next',
            prevEl: '#kncr_award_swiper_slide .swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 750px
            750: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
    

});